// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";

const OrderCancelNotification = getWidgetComponent("OrderDetails/OrderCancelNotification");

export interface OrderDetailsHeaderProps extends WidgetProps {}

export interface OrderDetailsHeaderStyles {}

export const orderDetailsHeaderStyles: OrderDetailsHeaderStyles = {};

const styles = orderDetailsHeaderStyles;

const OrderDetailsHeader: FC<OrderDetailsHeaderProps> = ({ id }) => {
    const currentPage = useCurrentPage();
    const linkBack = usePageLinkByPageType(constants.pageType.orderHistory);

    return (
        <OrderHeader title={currentPage.fields.title} linkBack={linkBack} message={<OrderCancelNotification />}>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsHeader,
    definition: {
        group: "Order Details",
        displayName: "Header",
        allowedContexts: ["OrderDetailsPage"],
    },
};

export default widgetModule;
